<div class="grid-container">
  <create-password [correlationId]="correlationId" [mfaToken]="mfaToken" (resetPasswordCompleted)="resetPasswordCompleted($event)"></create-password>
</div>
